var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { ProgressBar } from '@cvent/carina-progress-indicator';
import useStyle from './StepperProgressBarStyles';
import usePercentageData from './PercentageData';
var StepperProgressBar = function (_a) {
    var steps = _a.steps, isRtl = _a.isRtl, label = _a.label;
    var _b = useStyle(isRtl), progressBarLabel = _b.progressBarLabel, progressBarPercentage = _b.progressBarPercentage, statusWrapper = _b.statusWrapper, wrapper = _b.wrapper;
    var _c = __read(usePercentageData(steps), 2), stepCount = _c[0], lastCompletedIndex = _c[1];
    var percentage = Math.round((lastCompletedIndex / stepCount) * 100);
    return (_jsxs(Fragment, { children: [_jsxs("div", __assign({ css: statusWrapper }, { children: [_jsx("div", __assign({ css: progressBarLabel }, { children: label }), void 0),
                    _jsxs("div", __assign({ css: progressBarPercentage }, { children: [percentage, "%"] }), void 0)] }), void 0),
            _jsx("div", __assign({ css: wrapper }, { children: _jsx(ProgressBar, { value: lastCompletedIndex, total: stepCount, size: "l" }, void 0) }), void 0)] }, void 0));
};
export default StepperProgressBar;
